import React, { ReactElement } from 'react';
import GroupsBreadcrumbs from 'components/Groups/Breadcrumb';
import './styles.scss';

interface Props {
  children?: ReactElement;
  title?: string;
}

const GroupsPageHeader = ({ children = null, title = null }) => {
  return (
    <div className="groups-page-header">
      <GroupsBreadcrumbs titles={title !== null ? ['Group Overview', title] : ['Groups']} />
      {children}
    </div>
  );
};

export default GroupsPageHeader;
